import { DeleteOutline } from '@material-ui/icons';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

@autobind
export default class SelectedProducts extends Component {
    static propTypes = {
        items: PropTypes.array.isRequired,
        onUpdate: PropTypes.func.isRequired,
        onRemove: PropTypes.func.isRequired,
        getQuantityOptions: PropTypes.func,
    };

    render() {
        return (
            <table style={{width:'100%', borderCollapse:'collapse',}}>
                <thead>
                    <tr style={{fontWeight:600, textAlign:'left'}}>
                        <th style={{padding:10}}>Categoría</th>
                        <th>Cartel</th>
                        <th>Cantidad</th>
                        <th />
                    </tr>
                </thead>
                <tbody style={{border: '1px solid lightgray', backgroundColor:'whitesmoke'}}>
                    {this.props.items.map(item => (
                        <tr key={item.item}>
                            <td style={{padding:10, width:'30%'}}>
                                {item.category.name}
                            </td>
                            <td style={{padding:10, width:'30%'}}>
                                {item.name}
                            </td>
                            <td style={{padding:10, width:'30%'}}>
                                {item.quantity}
                            </td>
                            <td style={{padding:10, width:'10%', textAlign:'end'}}>
                                <button
                                    type='button'
                                    onClick={this.props.onRemove(item.item)}
                                >
                                    <DeleteOutline />
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    }
}



// WEBPACK FOOTER //
// ./components/new-product-picker/selected-products/index.js